import { type TvCategory } from '@setplex/tria-api'

export enum CategoryType { // used also as `sortOrder` value
  Favorite = -3,
  All = -2,
  Featured = -1,
  Regular = 0,
}

export type TvCategoryEx = TvCategory & {
  type: CategoryType
  channelIds: number[]
}

export enum CategoryId {
  Favorite = -2,
  Featured = -1,
  All = 0,
  Regular = NaN, // real category id is used instead
}
